import React, { useState, useEffect, useCallback } from "react";
import "./GirlAnimation.css";

const GirlAnimation2 = ({ size = 45, speed = 500 }) => {
  const [currentFrame, setCurrentFrame] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [cachedImages, setCachedImages] = useState({});
  const totalFrames = 3; // proneStab_0.png to proneStab_2.png

  // Preload and cache images
  const preloadImages = useCallback(async () => {
    const cacheKey = "girl-animation-main-images";
    const cacheVersion = "v2";
    const fullCacheKey = `${cacheKey}-${cacheVersion}`;

    try {
      // Check if images are already cached in localStorage
      const cachedData = localStorage.getItem(fullCacheKey);
      if (cachedData) {
        const parsed = JSON.parse(cachedData);
        setCachedImages(parsed);
        setImagesLoaded(true);
        return;
      }

      // Preload images and convert to base64 for caching
      const imagePromises = [];
      const imageCache = {};

      for (let i = 0; i < totalFrames; i++) {
        const imagePath = `/girl_animation_1/proneStab_${i}.png`;

        const promise = new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => {
            // Convert image to base64 for localStorage
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            const base64 = canvas.toDataURL("image/png");
            imageCache[i] = base64;
            resolve();
          };
          img.onerror = reject;
          img.src = imagePath;
        });

        imagePromises.push(promise);
      }

      await Promise.all(imagePromises);

      // Cache images in localStorage
      localStorage.setItem(fullCacheKey, JSON.stringify(imageCache));
      setCachedImages(imageCache);
      setImagesLoaded(true);
    } catch (error) {
      console.warn("Failed to cache girl animation images:", error);
      // Fallback to direct URLs without caching
      setImagesLoaded(true);
    }
  }, [totalFrames]);

  useEffect(() => {
    preloadImages();
  }, [preloadImages]);

  useEffect(() => {
    if (!imagesLoaded) return;

    const interval = setInterval(() => {
      setCurrentFrame((prev) => (prev + 1) % totalFrames);
    }, speed);

    return () => clearInterval(interval);
  }, [speed, totalFrames, imagesLoaded]);

  // Handle both px and percentage sizes
  const getSize = (sizeValue) => {
    if (typeof sizeValue === "string") {
      return sizeValue;
    }
    return `${sizeValue}px`;
  };

  // Get current image source (cached base64 or fallback to URL)
  const getCurrentImageSrc = () => {
    const src = cachedImages[currentFrame]
      ? cachedImages[currentFrame]
      : `/girl_animation_1/proneStab_${currentFrame}.png`;
    console.log(
      `[GirlAnimation2] Frame ${currentFrame} src:`,
      src.substring(0, 50) + "..."
    );
    return src;
  };

  console.log(
    `[GirlAnimation] imagesLoaded: ${imagesLoaded}, size: ${size}, currentFrame: ${currentFrame}`
  );

  if (!imagesLoaded) {
    // Show static first frame while loading
    console.log(
      `[GirlAnimation] Showing loading state with size: ${getSize(size)}`
    );
    return (
      <div
        className="girl-animation"
        style={{
          width: getSize(size),
          height: getSize(size),
          backgroundImage: `url(/girl_animation_1/proneStab_0.png)`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      />
    );
  }

  return (
    <div
      className="girl-animation"
      style={{
        width: getSize(size),
        height: getSize(size),
        backgroundImage: `url(${getCurrentImageSrc()})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    />
  );
};

export default GirlAnimation2;
